import Debug from 'debug';
import * as Turbo from "@hotwired/turbo"

import {logger} from './logger.ts';
import './styles.generated.css'
import '@root/server/client/esweb/src/lib/valibot/valibot.en.ts';

import {Application} from "@hotwired/stimulus"
import {loadStimulusControllers, loadWebComponents} from "./autoload.ts";

const debug = Debug('app:client:index');

console.log('Hello from client/index.js!');

declare global {
  interface Window {
    stimulusApplication: Application;
    Turbo: typeof Turbo;
    t: <T>(params: Record<string, T>) => T;
  }
}

window.Turbo = Turbo;
window.stimulusApplication = Application.start()


const application = window.stimulusApplication;
application.debug = true;

loadStimulusControllers(application);
loadWebComponents();


function turboDebug() {
  const turboEvents = [
    'turbo:before-visit',
    'turbo:visit',
    'turbo:after-visit',
    'turbo:before-cache',
    'turbo:before-render',
    'turbo:render',
    'turbo:load',
    'turbo:before-stream-render',
    'turbo:click',
    'turbo:before-frame-render',
    'turbo:frame-render',
    'turbo:morph',
    'turbo:before-morph-element',
    'turbo:morph-element',
    'turbo:scroll',
    'turbo:before-fetch-request',
    'turbo:before-fetch-response',
    'turbo:fetch-request-error',
    'turbo:fetch-response-error',
    'turbo:submit-start',
    'turbo:submit-end',
    'turbo:before-submit',
    'turbo:submit',
    'turbo:before-replace',
    'turbo:frame-missing',
    'turbo:disconnect',
    'turbo:connect'
  ];

  turboEvents.forEach(eventName => {
    window.addEventListener(eventName, (event) => {
      debug(`${eventName} event`, event);
    });
  });

}
turboDebug();

// @ts-expect-error
window.addEventListener('turbo:frame-missing', async (event: CustomEvent) => {
  debug('turbo:frame-missing', event);
  const frame = event.target as HTMLElement;
  const responseHTML = await event.detail.response.text();
  debug('responseHTML', responseHTML);
  const parser = new DOMParser();
  const doc = parser.parseFromString(responseHTML, 'text/html');
  const fallbackFrame = doc.getElementById('fallback-frame');
  if(fallbackFrame) {
    frame.innerHTML = fallbackFrame.innerHTML;
  }
})

//
// window.addEventListener('turbo:before-frame-render', (event: MessageEvent) => {
//   debug('turbo:before-frame-render', event);
// })

// @ts-expect-error
window.addEventListener('turbo:fetch-request-error', (event: CustomEvent) => {
  logger.error('fetch request-error', event);

  debug('event.details.request.delegate', event.detail.request.delegate.constructor.name);

  if(['LinkPrefetchObserver'].includes(event.detail?.request?.delegate?.constructor?.name)) {
    debug('not showing error to user');
    return;
  }

  const flashContainer = document.getElementById('flash-message-container');
  const flashMessageTemplate = document.getElementById('flash-message-error-template') as HTMLTemplateElement;

  debug('flashMessageTemplate', flashMessageTemplate);
  debug('flashContainer', flashContainer);
  if (flashContainer && flashMessageTemplate) {
    const clone = flashMessageTemplate.content.cloneNode(true);
    flashContainer.appendChild(clone);
  }
});

